import getConfig from 'next/config';
import { loggerFactory as ReactAnalyticsLoggerFactory } from '@cvent/react-analytics';

const { publicRuntimeConfig } = getConfig();

if (typeof window !== 'undefined') {
  // Set React Analytics library log level according to this application's log level
  ReactAnalyticsLoggerFactory.setLogLevel(publicRuntimeConfig.LOG_LEVEL?.toLowerCase());
}
